<template>
  <SpPopover class="OpenDatePicker" width="670" height="547">
    <template #reference>
      <slot />
    </template>
    <div class="mg-b-30 mg-t-10 text-center">
      <span class="font18 italic-bold">{{ title }}</span> <span class="sp-color-14">*</span>
    </div>
    <div class="flex-jc-bt">
      <div class="flex-1">
        <div class="date-item flex-jc-bt right">
          <div class="left">
            <span class="font14 italic-bold">Earliest Date</span>
          </div>
          <div class="flex-1">
            <SpDatePicker v-model="cargoOrders.earliestLaycan" class="date-picker" :name="cargoOrders.earliestLaycan" :show-close="false"
                          width="1" type="warn4" border filter height="40" placeholder=" " />
          </div>
        </div>
      </div>
      <div class="flex-1">
        <div class="date-item flex-jc-bt left">
          <div class="left">
            <span class="font14 italic-bold">Latest Date</span>
          </div>
          <div class="flex-1">
            <SpDatePicker v-model="cargoOrders.latestLaycan" class="date-picker" :name="cargoOrders.latestLaycan" :show-close="false"
                          width="1" type="warn4" border filter height="40" placeholder=" " />
          </div>
        </div>
      </div>
    </div>
    <p class="sp-color-1" style="margin-top: 26px; margin-bottom: 6px;padding-left: 24px">Shortcut</p>
    <SpRadioGroup v-model="shortcutType">
      <div class="flex-jc-bt mg-b-20">
        <div class="flex-1">
          <div class="date-item flex-jc-bt right">
            <div class="left">
              <SpRadio value="onAround" class="date-radio flex-30">
                <span class="font14">On Arround</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.onAround.defaultDate" class="shortcut-date-picker" :class="{'show-label': shortcutType === 'onAround'}"
                            :show-close="false"
                            :disabled="shortcutType !== 'onAround'"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div class="date-item flex-jc-start left">
            <SpRadio value="prompt" class="flex-40">
              <span class="font14">Prompt</span>
            </SpRadio>
            <SpRadio value="spot" class="flex-30">
              <span class="font14">Spot</span>
            </SpRadio>
          </div>
        </div>
      </div>
      <div class="flex-jc-bt mg-b-5">
        <div class="flex-1">
          <div class="date-item flex-jc-bt right">
            <div class="left">
              <SpRadio value="early" class="date-radio flex-30">
                <span class="font14">Early</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.early.defaultDate" class="shortcut-date-picker" picker-type="month" :show-close="false"
                            :disabled="shortcutType !== 'early'"
                            :class="{'show-label': shortcutType === 'early'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
        <div class="flex-1" />
      </div>
      <div class="flex-jc-bt mg-b-5">
        <div class="flex-1">
          <div class="date-item flex-jc-bt right">
            <div class="left">
              <SpRadio value="mid" class="date-radio flex-30">
                <span class="font14">Mid</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.mid.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :disabled="shortcutType !== 'mid'" picker-type="month"
                            :class="{'show-label': shortcutType === 'mid'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
        <div class="flex-1" />
      </div>
      <div class="flex-jc-bt mg-b-20">
        <div class="flex-1">
          <div class="date-item flex-jc-bt right">
            <div class="left">
              <SpRadio value="end" class="date-radio flex-30">
                <span class="font14">End</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.end.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :disabled="shortcutType !== 'end'" picker-type="month"
                            :class="{'show-label': shortcutType === 'end'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
        <div class="flex-1" />
      </div>
      <div class="flex-jc-bt mg-b-5">
        <div class="flex-1">
          <div class="date-item flex-jc-bt right">
            <div class="left">
              <SpRadio value="week1" class="date-radio flex-30">
                <span class="font14">1st Week</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.week1.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :disabled="shortcutType !== 'week1'" picker-type="month"
                            :class="{'show-label': shortcutType === 'week1'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div class="date-item flex-jc-bt left">
            <div class="left">
              <SpRadio value="week3" class="date-radio flex-30">
                <span class="font14">3rd Week</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.week3.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :disabled="shortcutType !== 'week3'" picker-type="month"
                            :class="{'show-label': shortcutType === 'week3'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
      </div>
      <div class="flex-jc-bt mg-b-20">
        <div class="flex-1">
          <div class="date-item flex-jc-bt right">
            <div class="left">
              <SpRadio value="week2" class="date-radio flex-30">
                <span class="font14">2nd Week</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.week2.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :class="{'show-label': shortcutType === 'week2'}"
                            :disabled="shortcutType !== 'week2'" picker-type="month"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div class="date-item flex-jc-bt left">
            <div class="left">
              <SpRadio value="week4" class="date-radio flex-30">
                <span class="font14">4th Week</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.week4.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :disabled="shortcutType !== 'week4'" picker-type="month"
                            :class="{'show-label': shortcutType === 'week4'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
      </div>
      <div class="flex-jc-bt">
        <div class="flex-1">
          <div class="date-item flex-jc-bt right">
            <div class="left">
              <SpRadio value="half1" class="date-radio flex-30">
                <span class="font14">1st Half</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.half1.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :disabled="shortcutType !== 'half1'" picker-type="month"
                            :class="{'show-label': shortcutType === 'half1'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div class="date-item flex-jc-bt left">
            <div class="left">
              <SpRadio value="half2" class="date-radio flex-30">
                <span class="font14">2nd Half</span>
              </SpRadio>
            </div>
            <div class="flex-1">
              <SpDatePicker v-model="shortcutObj.half2.defaultDate" class="shortcut-date-picker" :show-close="false"
                            :disabled="shortcutType !== 'half2'" picker-type="month"
                            :class="{'show-label': shortcutType === 'half2'}"
                            width="1" type="warn4" border filter height="40" placeholder=" " />
            </div>
          </div>
        </div>
      </div>
    </SpRadioGroup>
  </SpPopover>
</template>

<script type="text/ecmascript-6">
import SpDatePicker from '@/components/common/SpDatePicker'
import SpRadio from '@/components/common/SpRadio.vue'
import SpRadioGroup from '@/components/common/SpRadioGroup'
import { computed } from '@vue/runtime-core'
import SpPopover from '@/components/common/SpPopover'
import { reactive, ref, watch } from 'vue'
import moment from 'moment'
import { getDateToFormatEn } from '@/utils/convert'
export default {
  name: 'OpenDatePicker',

  nameSpace: 'OpenDatePicker',

  components: {
    SpPopover,
    SpDatePicker,
    SpRadio,
    SpRadioGroup
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {
          nodeId: null
        }
      }
    },

    title: {
      type: String,
      default: 'Laycan'
    }
  },

  emits: ['update:modelValue'],

  setup (props, ctx) {
    const cargoOrders = computed({
      get () {
        return props.modelValue
      },
      set (nv) {
        ctx.emit('update:modelValue', nv)
      }
    })
    const shortcutObj = reactive({
      onAround: {
        key: 'onAround',
        check: false,
        defaultDate: new Date()
      },
      prompt: {
        key: 'prompt',
        check: false,
        defaultDate: new Date()
      },
      spot: {
        key: 'spot',
        check: false,
        defaultDate: new Date()
      },
      early: {
        key: 'early',
        check: false,
        defaultDate: moment(new Date()).add(1, 'months').startOf('month').format('YYYY-MM-DD')
      },
      mid: {
        key: 'mid',
        check: false,
        defaultDate: moment(new Date()).add(0, 'months').startOf('month').format('YYYY-MM-DD')
      },
      end: {
        key: 'end',
        check: false,
        defaultDate: moment(new Date()).add(0, 'months').startOf('month').format('YYYY-MM-DD')
      },
      week1: {
        key: 'week1',
        check: false,
        defaultDate: moment(new Date()).add(1, 'months').startOf('month').format('YYYY-MM-DD')
      },
      week2: {
        key: 'week2',
        check: false,
        defaultDate: moment(new Date()).add(1, 'months').startOf('month').format('YYYY-MM-DD')
      },
      week3: {
        key: 'week3',
        check: false,
        defaultDate: moment(new Date()).add(0, 'months').startOf('month').format('YYYY-MM-DD')
      },
      week4: {
        key: 'week4',
        check: false,
        defaultDate: moment(new Date()).add(0, 'months').startOf('month').format('YYYY-MM-DD')
      },
      half1: {
        key: 'half1',
        check: false,
        defaultDate: moment(new Date()).add(1, 'months').startOf('month').format('YYYY-MM-DD')
      },
      half2: {
        key: 'half2',
        check: false,
        defaultDate: moment(new Date()).add(0, 'months').startOf('month').format('YYYY-MM-DD')
      }
    })
    const shortcutType = ref('')

    const earliestLaycanShortcut = ref('')
    const latestLaycanShortcut = ref('')
    watch([() => shortcutType.value, shortcutObj], (val, old) => {
      if (shortcutType.value) {
        const baseDate = shortcutObj[shortcutType.value].defaultDate
        switch (true) {
          case shortcutType.value === 'onAround':
            cargoOrders.value.earliestLaycan = moment(baseDate).subtract(1, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(1, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `On Around ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false)}`
            break
          case shortcutType.value === 'prompt':
            cargoOrders.value.earliestLaycan = moment(baseDate).subtract(0, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(5, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = 'Prompt'
            break
          case shortcutType.value === 'spot':
            cargoOrders.value.earliestLaycan = moment(baseDate).subtract(0, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(3, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = 'Spot'
            break
          case shortcutType.value === 'early':
            cargoOrders.value.earliestLaycan = moment(baseDate).startOf('month').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(9, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `Early ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'mid':
            cargoOrders.value.earliestLaycan = moment(baseDate).add(10, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(19, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `Mid ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'end':
            cargoOrders.value.earliestLaycan = moment(baseDate).add(20, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).endOf('month').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `End ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'week1':
            cargoOrders.value.earliestLaycan = moment(baseDate).startOf('month').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(6, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `1st Week ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'week2':
            cargoOrders.value.earliestLaycan = moment(baseDate).add(7, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(13, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `2nd Week ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'week3':
            cargoOrders.value.earliestLaycan = moment(baseDate).add(14, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(20, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `3rd Week ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'week4':
            cargoOrders.value.earliestLaycan = moment(baseDate).add(21, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).endOf('month').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `4th Week ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'half1':
            cargoOrders.value.earliestLaycan = moment(baseDate).startOf('month').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).add(14, 'days').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `1st Half ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
          case shortcutType.value === 'half2':
            cargoOrders.value.earliestLaycan = moment(baseDate).add(14, 'days').format('YYYY-MM-DD')
            cargoOrders.value.latestLaycan = moment(baseDate).endOf('month').format('YYYY-MM-DD')
            cargoOrders.value.laycanLabels = `2nd Half ${getDateToFormatEn(moment(baseDate).format('YYYY-MM-DD'), false, true, false)}`
            break
        }
        earliestLaycanShortcut.value = cargoOrders.value.earliestLaycan
        latestLaycanShortcut.value = cargoOrders.value.latestLaycan
      }
    })

    watch([() => cargoOrders.value.earliestLaycan, () => cargoOrders.value.latestLaycan], () => {
      if (cargoOrders.value.earliestLaycan && cargoOrders.value.latestLaycan) {
        if (moment(earliestLaycanShortcut.value).format('YYYY-MM-DD') !== moment(cargoOrders.value.earliestLaycan).format('YYYY-MM-DD') || moment(latestLaycanShortcut.value).format('YYYY-MM-DD') !== moment(cargoOrders.value.latestLaycan).format('YYYY-MM-DD')) {
          shortcutType.value = ''
          cargoOrders.value.laycanLabels = ''
        }
      } else {
        shortcutType.value = ''
        cargoOrders.value.laycanLabels = ''
      }
    })

    return {
      cargoOrders,
      shortcutObj,
      shortcutType,
      getDateToFormatEn,
      moment,
      earliestLaycanShortcut,
      latestLaycanShortcut
    }
  },

  computed: {
  },

  created () {
  },

  mounted () {
  },

  methods: {
  }
}
</script>

<style scoped lang="less">
/deep/.date-picker-year-month>.input{
    justify-content: center;
}
.date-item{
  &.right {
    padding: 0 34px 0 24px;
    .left {
      line-height: 40px;
      width: 115px;
    }
  }
  &.left {
    padding: 0 24px 0 34px;
    .left {
      line-height: 40px;
      width: 115px;
    }
  }

  height: 40px;
  line-height: 40px;
}
</style>

<style lang="less">
.date-radio {
  .label {
    color: #000000;
    //opacity: 1 !important;
    &.label-right{
      margin: 0;
      text-align: right;
      padding-right: 10px;
    }
  }
}
.date-picker, .shortcut-date-picker{
  .input {
    img {
      width: 26px !important;
      height: 26px !important;
      padding-left: 8px !important;
      padding-right: 0 !important;
    }
    .label {
      margin: 0 auto;
      color: #000000 !important;
    }
  }
}
.shortcut-date-picker{
  &.show-label{
    .input {
      .label {
        visibility: visible;
      }
    }
  }
  .input {
    .label {
      visibility: hidden;
    }
  }
}
</style>
